import React, { Component } from 'react'
import { Player, ControlBar, ReplayControl } from 'video-react'
import './video-react.css'

export default class VideoPlayer extends Component {
  componentDidMount(){
    setTimeout(()=>this.refs['playa'].play(), 500)
  }
  render() {
    return (
      <Player
        // playsInline
        // autoPlay
        preload
        poster={this.props.thumbnail}
        src={this.props.src}
        ref={'playa'}
      >
        <ControlBar autoHide/>
      </Player>
    )
  }
}
